<div class="wizard__wrapper__summary">
  <div class="row">
    <div class="col-xl-6 col-lg-6">
      <div class="row">
        <div class="col-xl-12">
          <h2>
            <span>{{ "Finishing touches" | translate }}</span>
            <span *ngIf="experienceOrigin"
              ><a
                class="origin__icon"
                href="{{ experienceOriginUrl }}"
                target="_blank"
              ></a
            ></span>
          </h2>
          <p class="general__tip">
            {{ "Finishing tip" | translate }}
          </p>
        </div>
      </div>
      <div class="btn-group btn--switcher" role="group">
        <button
          *ngFor="let lang of LANGUAGE | keyvalue"
          (click)="changeLanguage(lang.value)"
          [ngClass]="{
            'button--active': generalInfoByLang.language == lang.value
          }"
          type="button"
          class="btn"
        >
          {{ lang.key }}
        </button>
      </div>
      <div class="row mb-5">
        <div class="col-xl-12">
          <h3>{{ "Cover image" | translate }}</h3>
          <div class="summary__cover__image">
            <img
              src
              *ngIf="generalInfoByLang.selectedCoverImage"
              [src]="generalInfoByLang.selectedCoverImage"
            />
          </div>
        </div>
      </div>
      <div
        *ngIf="generalInfoByLang.loadedImagesArray.length > 0"
        class="row mb-5"
      >
        <div class="col-xl-12">
          <h3>{{ "Gallery image" | translate }}</h3>
          <div
            *ngIf="generalInfoByLang.loadedImagesArray"
            class="cropped__images__wrapper"
          >
            <div class="row">
              <div
                *ngFor="
                  let gallery of generalInfoByLang?.loadedImagesArray;
                  let i = index
                "
                class="cropped__image col-xl-4 col-lg-4 col-md-4 col-sm-4 col-4 mb-3"
              >
                <div
                  class="cropped__image__background"
                  [style.background-image]="'url(' + gallery.original + ')'"
                ></div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-xl-12">
          <h3>{{ "General information" | translate }}</h3>
          <form>
            <div class="form-row">
              <div class="form-group mb-4 col-md-12 form--nopadding">
                <input
                  [(ngModel)]="
                    generalInfoByLang.dataByLang[generalInfoByLang.language]
                      .title
                  "
                  type="text"
                  class="form-control"
                  id="name_summary"
                  name="name"
                  placeholder="Experience name"
                  disabled
                />
              </div>
            </div>
            <div class="form-row">
              <div class="form-group col-md-12 form--nopadding">
                <textarea
                  [(ngModel)]="
                    generalInfoByLang.dataByLang[generalInfoByLang.language]
                      .description
                  "
                  type="text"
                  class="form-control"
                  id="description_summary"
                  name="description"
                  placeholder="Experience name"
                  disabled
                ></textarea>
              </div>
            </div>
          </form>
          <div class="experience__categories clearfix mb-2">
            <span
              [ngClass]="{
                active:
                  generalInfoByLang.dataByLang[generalInfoByLang.language]
                    .typeIndex == i
              }"
              class="experience__categorie summary--categorie"
              *ngFor="let cat of categories; index as i"
              >{{ cat.name | translate }}</span
            >
          </div>
          <div
            *ngIf="
              generalInfoByLang.dataByLang[generalInfoByLang.language]
                .scheduleExperience
            "
          >
            <div
              *ngFor="
                let exp of generalInfoByLang.dataByLang[
                  generalInfoByLang.language
                ].scheduleExperience
              "
              class="datebox__wrapper datebox--summary clearfix"
            >
              <div class="datepicker__datebox">
                <span class="icon"></span>
                <div class="datepicker__datebox__time__wrap">
                  <label>{{ "Start" | translate }}</label>
                  <span
                    >{{ exp.startHour }}, {{ exp.startDateDay }}
                    {{ exp.startDateMonth | translate }}</span
                  >
                </div>
              </div>
              <div class="datepicker__datebox">
                <span class="icon"></span>
                <div class="datepicker__datebox__time__wrap">
                  <label>{{ "end" | translate }}</label>
                  <span
                    >{{ exp.endHour }}, {{ exp.endDateDay }}
                    {{ exp.endDateMonth | translate }}</span
                  >
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="row">
        <div class="col-xl-12">
          <h3>{{ "Location & address" | translate }}</h3>
        </div>
      </div>

      <experience-location
        [latitude]="
          generalInfoByLang.dataByLang[this.generalInfoByLang.language].latitude
        "
        [longitude]="
          generalInfoByLang.dataByLang[this.generalInfoByLang.language]
            .longitude
        "
        [locationAddress]="
          generalInfoByLang.dataByLang[this.generalInfoByLang.language]
            .locationAddress
        "
        [locationDesc]="
          generalInfoByLang.dataByLang[this.generalInfoByLang.language]
            .locationDescription
        "
        [city]="
          generalInfoByLang.dataByLang[this.generalInfoByLang.language].city
        "
        [country]="
          generalInfoByLang.dataByLang[this.generalInfoByLang.language].country
        "
        [experience]="experienceId"
        [language]="generalInfoByLang.language"
        [locationName]="
          generalInfoByLang.dataByLang[this.generalInfoByLang.language]
            .locationName
        "
        [disabled]="true"
        [clickBool]="false"
        [draggable]="false"
      >
      </experience-location>
    </div>
    <div class="col-xl-5 offset-xl-1 tips">
      <div
        *ngIf="hasIssue && hasComments"
        class="general__tips general__tips--red"
      >
        <h2 class="text-danger">
          {{ "You have unresolved issues" | translate }}
        </h2>
        <div *ngFor="let comment of comments; index as i">
          <h3 *ngIf="!comment.isResolved && comment.type == 'INFO'">
            {{ "General information" | translate }}
          </h3>
          <h3 *ngIf="!comment.isResolved && comment.type == 'SCHEDULE'">
            {{ "Schedule information" | translate }}
          </h3>
          <h3 *ngIf="!comment.isResolved && comment.type == 'LOCATION'">
            {{ "Location information" | translate }}
          </h3>
          <h3 *ngIf="!comment.isResolved && comment.type == 'IMAGES'">
            {{ "Images information" | translate }}
          </h3>
          <p *ngIf="!comment.isResolved" class="text-danger">
            {{ comment.comment }}
          </p>
        </div>
      </div>

      <div
        *ngIf="!hasIssue && hasComments"
        class="general__tips general__tips--green"
      >
        <h2 class="text-success">
          {{ "All your issues have been resolved" | translate }}
        </h2>
      </div>
    </div>
  </div>
</div>
